import React, { useState } from 'react';
const PercentageDifferenceCalculator = () => {
  const [value1, setValue1] = useState('');
  const [value2, setValue2] = useState('');
  const [result, setResult] = useState('');
  const [explanation, setExplanation] = useState('');
  const [error, setError] = useState('');
  const handleCalculate = () => {
    if (!value1 || !value2) {
      setError('Please enter both values correctly');
      setResult('');
      setExplanation('');
      return;
    }
    const diff = Math.abs(parseFloat(value1) - parseFloat(value2));
    const sum = parseFloat(value1) + parseFloat(value2);
    const percentageDiff = (diff / sum) * 100;
    setResult(percentageDiff.toFixed(3));
    setExplanation(
      `The difference between ${value1} and ${value2} = |${value1} - ${value2}| = ${diff}\n(${value1} + ${value2}) / 2 = ${sum} / 2 = ${sum / 2}\n= ${diff} / ${sum / 2} = ${(diff / (sum / 2)).toFixed(
        3
      )}\n= ${(percentageDiff).toFixed(3)}%\n= ${percentageDiff.toFixed(3)}`
    );
    setError('');
  };
  return (
    <div dir="ltr">
      <u><h2 style={{ fontSize: '16px' }}>Percentage Difference Calculator</h2></u><br/>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <span>The difference between</span>
        <input
          type="number"
          placeholder="Value 1"
          value={value1}
          onChange={(e) => setValue1(e.target.value)}
          className="form-control ml-2"
          style={{ width: '80px', marginRight: '5px', marginLeft: '5px' }}
        />
        <span>and</span>
        <input
          type="number"
          placeholder="Value 2"
          value={value2}
          onChange={(e) => setValue2(e.target.value)}
          className="form-control ml-2"
          style={{ width: '80px', marginLeft: '5px', marginRight: '5px' }}
        />
        <span>is</span>
        <button
          className="btn btn-success"
          style={{ fontSize: '20px', marginRight: '5px' }}
          onClick={handleCalculate}
        >
          Calculate
        </button>
      </div>
      <br/>
      <div>
        {error !== '' ? (
          <p className='p-3 mb-2 bg-warning text-white'>Error: {error}</p>
        ) : (
          <>
            {result !== '' && (
              <>
                <p className='p-3 mb-2 bg-success text-white'>
                  Result: The difference between {value1} and {value2} is {result}%
                </p>
                {explanation !== '' && (
                  <p className='p-3 mb-2 bg-info text-black'>
                    Solution Steps: <br/>{explanation}
                  </p>
                )}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};
export default PercentageDifferenceCalculator;
